import React, { PropTypes } from 'react'
import { Link } from 'react-router'
import MiniPlayer from '../../components/miniPlayer/MiniPlayer'
import { ORIGIN_PLAYQUEUE_TYPES } from '../../components/miniPlayer/AudioPlayer/playerConstants'
import * as shapes from '../../constant/shapes'
import appConst from '../../constant/appConst'
import GTMController from "../../utils/kpi/GTMController"

const FocusAlbumBloc = (props) => {
	const { album, current, playing } = props

	const releaseYear = new Date(album.released_at * 1000).getFullYear()
	let description = ''
	if (album.description) {
		if (album.description.length > appConst.albumBlocDescMaxLength) {
			const maxPos = album.description.lastIndexOf(' ', appConst.albumBlocDescMaxLength)
			description = `${album.description.substring(0, maxPos)}...`
		} else {
			description = album.description
		}
	}

	return (
		<div className={`card ${current ? (playing ? 'isPlaying' : 'isPause') : ''}`}>
			<div className="card__container">
				{album.image ?
					<img
						className="card__image"
						src={album.image}
						alt=""
						height="295"
						width="295"
					/>
				: ''}
				<div className="card__action">
					<div className="card__infos"></div>
					<Link className="card__linker" to={`/album/${album.id}`} />
					<MiniPlayer
						buttonClassName="card__button"
						element={album}
						type={ORIGIN_PLAYQUEUE_TYPES.album}
						GTMPlayEvent={GTMController.EVENTS.FOCUS_PLAY}
						sampleable={album.sampleable}
					/>
				</div>
			</div>
			<div className="card__meta">
				<p className="card__title">
					<Link className="card__link" to={`/album/${album.id}`}>
						{`${album.title} (${releaseYear})`}
					</Link>
				</p>
				{album.artist ?
					<Link to={`/artist/${album.artist.id}`}>
						<p className="card__subtitle">{album.artist.name}</p>
					</Link>
				: ''}
				{description ?
					<p className="card__description" dangerouslySetInnerHTML={{ __html: `${description}`.nl2br() }} />
				: ''}
			</div>
		</div>
	)
}

FocusAlbumBloc.propTypes = {
	album: shapes.albumCard,
	current: PropTypes.bool,
	playing: PropTypes.bool
}

export default FocusAlbumBloc



// WEBPACK FOOTER //
// ./src/pages/focus/FocusAlbumBloc.jsx